import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeFileExtension'
})
export class RemoveFileExtensionPipe implements PipeTransform {

  transform(value: string): string {
    if (value.indexOf('.') != -1) {
      return value.substring(0, value.lastIndexOf('.'))
    }
    return value
  }

}
